import axios from "axios";
import { getActiveToken, clearAllSessions } from "./auth";

/**
 * Attach a Bearer token to every outgoing axios request when present.
 * Routes through `lib/auth.js` for safe storage access (no crash in
 * iOS private mode / quotaExceeded).
 */
axios.interceptors.request.use((config) => {
  const token = getActiveToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.response?.config?.url || "";
      // Don't auto-logout for login attempts themselves
      if (
        !url.includes("/auth/login") &&
        !url.includes("/auth/admin") &&
        !url.includes("/auth/employee")
      ) {
        clearAllSessions();
        // Oct 2026 — notifier l'UI pour afficher l'écran de connexion
        // immédiatement (avant : l'utilisateur voyait « erreur non identifié »
        // et devait rafraîchir manuellement pour retomber sur le login).
        try {
          window.dispatchEvent(new CustomEvent("yo-auth-expired"));
        } catch (_e) { /* SSR/vieux navigateur */ }
      }
    }
    return Promise.reject(err);
  },
);

export default axios;
